<!-- Filter Panel -->
<div class="filter-panel">
    <div class="panel-header">
        <h3 class="panel-title">Search Filters</h3>
    </div>
    <form class="filter-form">
        <div class="filter-fields">
            <!-- User UUID -->
            <div class="field-group">
                <mat-form-field
                    appearance="fill"
                    class="minimal-field"
                >
                    <mat-label>User UUID</mat-label>
                    <input
                        matInput
                        [(ngModel)]="selectedUserUuid"
                        name="userUuid"
                        placeholder="31f806f-82db-4631-..."
                        (input)="onPaste($event)"
                    />
                </mat-form-field>
            </div>

            <!-- Status Filter -->
            <div class="field-group">
                <mat-form-field
                    appearance="fill"
                    class="minimal-field"
                >
                    <mat-label>Status</mat-label>
                    <mat-select
                        [(ngModel)]="statusFilter"
                        name="status"
                    >
                        <mat-option [value]="null">All</mat-option>
                        <mat-option [value]="1">Blocked</mat-option>
                        <mat-option [value]="0">Unblocked</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </form>
    <div class="filter-actions">
        <button
            mat-flat-button
            color="primary"
            (click)="applyFilters()"
            type="button"
            class="filter-btn"
        >
            <mat-icon>filter_list</mat-icon>
            Filter
        </button>
        <button
            mat-stroked-button
            (click)="clearFilters()"
            type="button"
            class="clear-btn"
        >
            <mat-icon>clear</mat-icon>
            Clear
        </button>
    </div>
</div>

<!-- Message Display -->
<div
    class="message-container"
    *ngIf="displayMessage"
>
    <div class="alert-message">
        <mat-icon>info</mat-icon>
        <span>{{ message }}</span>
    </div>
</div>

<!-- Manage Player Card -->
<mat-card
    class="manage-player-card"
    *ngIf="addUserClicked || editMode"
>
    <div class="card-header">
        <h3 class="card-title">Manage Player</h3>
    </div>
    <div class="card-content">
        <form
            [formGroup]="userForm"
            class="user-form"
        >
            <div class="form-fields">
                <mat-form-field
                    appearance="fill"
                    class="minimal-field"
                >
                    <mat-label>User UUID</mat-label>
                    <input
                        matInput
                        formControlName="userUuid"
                        required
                        [readonly]="editMode"
                    />
                    <mat-error
                        *ngIf="userForm.get('userUuid').hasError('required')"
                    >
                        User UUID is required
                    </mat-error>
                </mat-form-field>

                <mat-form-field
                    appearance="fill"
                    class="minimal-field"
                >
                    <mat-label>Reason for Blocking</mat-label>
                    <input
                        matInput
                        formControlName="reasonForBlocking"
                        required
                    />
                    <mat-error
                        *ngIf="
                            userForm
                                .get('reasonForBlocking')
                                .hasError('required')
                        "
                    >
                        Reason is required
                    </mat-error>
                </mat-form-field>

                <mat-form-field
                    appearance="fill"
                    class="minimal-field"
                >
                    <mat-label>Notes</mat-label>
                    <textarea
                        matInput
                        formControlName="notes"
                        rows="3"
                    ></textarea>
                </mat-form-field>
            </div>

            <div class="form-actions">
                <button
                    mat-flat-button
                    color="warn"
                    type="button"
                    (click)="blockUser()"
                >
                    <mat-icon>block</mat-icon>
                    Block
                </button>
                <button
                    mat-flat-button
                    color="primary"
                    type="button"
                    (click)="unblockUser()"
                >
                    <mat-icon>check_circle</mat-icon>
                    Unblock
                </button>
                <button
                    mat-stroked-button
                    type="button"
                    (click)="cancel()"
                >
                    <mat-icon>cancel</mat-icon>
                    Cancel
                </button>
            </div>
        </form>
    </div>
</mat-card>

<!-- Statistics Table -->
<div class="statistics-container">
    <mat-card class="table-card">
        <div class="table-header">
            <h3 class="table-title">Blocked Players</h3>
            <div>
                <button
                    mat-flat-button
                    color="accent"
                    (click)="toggleAddUser()"
                    type="button"
                    class="add-btn"
                    *ngIf="!editMode"
                >
                    <mat-icon>add</mat-icon>
                    Add User
                </button>
                <button
                    mat-icon-button
                    (click)="refreshAndResetFilters()"
                    class="refresh-btn"
                    matTooltip="Refresh"
                >
                    <mat-icon>refresh</mat-icon>
                </button>
            </div>
        </div>

        <div class="mat-table-holder">
            <table
                mat-table
                [dataSource]="dataSourceblockedPlayersTable"
                class="mat-elevation-z2"
            >
                <!-- Status Column -->
                <ng-container matColumnDef="status">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >
                        Status
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                        class="status-cell"
                    >
                        <span
                            class="status-badge"
                            [ngClass]="{
                                'status-blocked': element.status === 1,
                                'status-unblocked': element.status === 0
                            }"
                        >
                            <mat-icon>{{
                                element.status === 1 ? 'block' : 'check_circle'
                            }}</mat-icon>
                            {{ element.status === 1 ? 'Blocked' : 'Unblocked' }}
                        </span>
                    </td>
                </ng-container>

                <!-- User UUID Column -->
                <ng-container matColumnDef="userUuid">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >
                        User UUID
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                        class="uuid-cell"
                        [title]="element.userUuid"
                    >
                        {{ element.userUuid | slice: 0 : 24
                        }}{{ element.userUuid.length > 24 ? '...' : '' }}
                    </td>
                </ng-container>

                <!-- Reason Column -->
                <ng-container matColumnDef="reasonForBlocking">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >
                        Reason for Blocking
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                    >
                        {{ element.reasonForBlocking }}
                    </td>
                </ng-container>

                <!-- Notes Column -->
                <ng-container matColumnDef="notes">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >
                        Notes
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                    >
                        {{ element.notes || '-' }}
                    </td>
                </ng-container>

                <!-- Block DateTime Column -->
                <ng-container matColumnDef="blockDateTime">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >
                        Block Date/Time
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                        class="date-cell"
                    >
                        {{
                            element.blockDateTime
                                ? (element.blockDateTime
                                  | date: 'dd/MM/yyyy HH:mm')
                                : '-'
                        }}
                    </td>
                </ng-container>

                <!-- Blocked By Column -->
                <ng-container matColumnDef="blockedBy">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >
                        Blocked By
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                    >
                        {{ element.blockedBy || '-' }}
                    </td>
                </ng-container>

                <!-- Unblock DateTime Column -->
                <ng-container matColumnDef="unblockDateTime">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >
                        Unblock Date/Time
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                        class="date-cell"
                    >
                        {{
                            element.unblockDateTime
                                ? (element.unblockDateTime
                                  | date: 'dd/MM/yyyy HH:mm')
                                : '-'
                        }}
                    </td>
                </ng-container>

                <!-- Unblocked By Column -->
                <ng-container matColumnDef="unblockedBy">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >
                        Unblocked By
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                    >
                        {{ element.unblockedBy || '-' }}
                    </td>
                </ng-container>

                <tr
                    mat-header-row
                    *matHeaderRowDef="columnsBlockedPlayers; sticky: true"
                ></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: columnsBlockedPlayers"
                    (click)="highlightRow(row)"
                    [ngClass]="{ 'selected-row': row.id === selectedRowId }"
                    class="clickable-row"
                ></tr>
            </table>
        </div>
    </mat-card>
</div>
